var _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMonitor = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-monitor-icon lucide-monitor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 14,
  x: 2,
  y: 3,
  rx: 2
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  x2: 16,
  y1: 21,
  y2: 21
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  x2: 12,
  y1: 17,
  y2: 21
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMonitor);
export { ForwardRef as ReactComponent };